import {
  Box,
  Button,
  Card,
  CircularProgress,
  Grid,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import React, { useState } from 'react';
import { poppins300 } from 'theme/common.style';
import SigningcontractImage from 'assets/images/SigningcontractImage.png';
import {
  CONTRACT_FILE_UPLOAD,
  POST_AGENT_BANNER_CLOSE,
} from 'constant/app.config';
import { postApiCall } from 'api/apiService';
import FinalContractUploadDialog from 'component/BuyerRegistration/components/FinalContractUploadDialog';
import PrepareContractSignDialog from 'component/BuyerRegistration/components/PrepareContractSignDialog';

const SignNowIcon = () => {
  return (
    <svg
      width="28"
      height="26"
      viewBox="0 0 28 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 25C6.09753 22 8.64706 19 8.64706 16C8.64706 11.5 7.11765 11.5 5.58824 11.5C4.05882 11.5 2.48047 13.1275 2.52941 16C2.58141 19.072 5.06518 20.3155 6.35294 22C8.64706 25 10.1765 25.75 11.7059 23.5C12.726 22 13.4907 20.7505 14 19.75C15.5294 23.2495 17.5681 25 20.1176 25H23.9412"
        stroke="#4898F8"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M27.0005 22V4C27.0005 2.3185 25.6561 1 23.9416 1C22.2272 1 20.8828 2.3185 20.8828 4V22L23.9416 25L27.0005 22Z"
        stroke="#4898F8"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M20.8828 7H27.0005"
        stroke="#4898F8"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

const RequestedESignContract = (props) => {
  let {
    bannerDetails,
    isAgentDashboard,
    AgentGroupCall,
    getListInfo,
    setRequestEsignBannerClose,
  } = props;
  const theme = useTheme();
  const matchesmd = useMediaQuery(theme.breakpoints.down('md'));
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const matches450 = useMediaQuery(theme.breakpoints.down(450));

  const [openPrepareDialog, setOpenPrepareDialog] = useState(false);
  const [openFinalContractDialog, setOpenFinalContractDialog] = useState(false);
  const [uploadedPdf, setUploadedPdf] = useState(null);
  const [openUploadDialog, setOpenUploadDialog] = useState(false);
  const [uploadedContractUrl, setUploadedContractUrl] = useState(null);

  const handleOpenFinalContractDialog = () => {
    setOpenFinalContractDialog(true);
  };
  const handleCloseFinalContractDialog = () => {
    setOpenFinalContractDialog(false);
  };

  const BuyerName = bannerDetails?.buyerFullName;
  const buyerId = bannerDetails?.buyerId;

  const handleFinalContractSubmit = async (file) => {
    setUploadedPdf(file);
    setOpenUploadDialog(false);
    setOpenPrepareDialog(true);
    try {
      const formData = new FormData();
      formData.append('propertyId', Number(bannerDetails?.dashboardId));
      formData.append('vendorId', 0);
      formData.append('buyerId', buyerId);
      formData.append('contractFile', file);
      const response = await postApiCall(CONTRACT_FILE_UPLOAD, formData);

      if (response?.data?.status === 1) {
        setUploadedContractUrl(response.data.contractFile);
      }
    } catch (error) {}
  };

  const handleClosePrepareDialog = () => {
    setOpenPrepareDialog(false);
  };

  const handleCloseAllContractDialogs = () => {
    setOpenPrepareDialog(false);
    setOpenFinalContractDialog(false);
  };

  const [closeLoader, setCloseLoader] = useState(false);
  const handleRequestESignCloseApiCall = async () => {
    const propertyId = Number(bannerDetails?.propertyId);
    let input = {
      propertyId: propertyId,
      bannerCode: 'AGENT004', // confirm code
      bannerHeading: 'Request E-sign Agent',
      buyerId: buyerId,
    };

    try {
      setCloseLoader(true);

      const response = await postApiCall(POST_AGENT_BANNER_CLOSE, input);

      if (response?.data?.status == 1) {
        setRequestEsignBannerClose((prev) =>
          prev.includes(buyerId) ? prev : [...prev, buyerId]
        );
        if (!isAgentDashboard) {
          getListInfo();
        }
        if (isAgentDashboard) {
          AgentGroupCall();
        }
      } else {
        console.error('API call unsuccessful:', response);
      }
    } catch (error) {
      console.error('API call failed:', error);
    } finally {
      setCloseLoader(false);
    }
  };

  return (
    <>
      <Grid
        container
        sx={{
          scrollbarWidth: 'none',
          background: 'white',
          margin: '0 auto',
          zIndex: 1,
        }}
      >
        <Card
          variant="outlined"
          sx={{
            background: 'rgba(33, 132, 253, 0.8)',
            width: '100%',
            borderRadius: '20px',
            p: matchessm ? 0 : 2,
            display: 'flex',
            flexDirection: 'row',
            height: matchessm ? 390 : matchesmd ? 330 : 300,
          }}
        >
          <Grid container alignItems={'center'}>
            <Grid item xs={12} md={8} display="flex" alignItems="center">
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'start',
                  width: '100%',
                  px: matchessm ? 1.5 : 3,
                  gap: matchessm ? 2.5 : 0.6,
                }}
              >
                <Typography
                  sx={{
                    color: '#FFF',
                    fontWeight: 300,
                    fontSize: matchessm ? '10px' : '14px',
                    fontFamily: 'poppins',
                    textTransform: 'capitalize',
                    marginTop: '-10px',
                  }}
                >
                  {bannerDetails?.addressFull}
                </Typography>

                <Typography
                  sx={{
                    fontSize: !matches450 ? '32px' : '20px',
                    fontWeight: 600,
                    color: '#FFF',
                    fontFamily: 'poppins',
                  }}
                >
                  {BuyerName} has requested a contract for E-signing!
                </Typography>

                <Typography
                  sx={{
                    fontSize: matchessm ? '14px' : '16px',
                    ...poppins300,
                    marginTop: matchessm ? '10px' : '15px',
                    color: 'rgba(255, 255, 255, 1)',
                  }}
                >
                  Prepare the contract of sale for &nbsp;
                  <span
                    style={{
                      alignItems: 'center',
                      color: 'rgba(255, 255, 255, 1)',
                      fontWeight: matchessm ? 400 : 700,
                      fontSize: matchessm ? '14px' : '16px',
                      fontFamily: 'poppins',
                      textTransform: 'capitalize',
                    }}
                  >
                    {bannerDetails?.addressFull}
                  </span>
                  &nbsp; and send the E-sign request to &nbsp;
                  <span
                    style={{
                      alignItems: 'center',
                      color: 'rgba(255, 255, 255, 1)',
                      fontWeight: matchessm ? 400 : 700,
                      fontSize: matchessm ? '14px' : '16px',
                      fontFamily: 'poppins',
                      textTransform: 'capitalize',
                    }}
                  >
                    {BuyerName}
                  </span>
                  &nbsp; now.
                </Typography>

                <Stack
                  direction="row"
                  spacing={2}
                  mt={2.5}
                  alignItems="center"
                  flexWrap="wrap"
                  justifyContent={matchessm && 'space-between'}
                >
                  <Button
                    disabled={closeLoader}
                    onClick={handleRequestESignCloseApiCall}
                    endIcon={closeLoader && <CircularProgress size="20px" />}
                    sx={{
                      px: 4,
                      height: matchessm ? 35 : 42,
                      borderRadius: '5px',
                      fontSize: matchessm ? '12px' : '14px',
                      textTransform: 'none',
                      border: '1px solid #E6F2FF',
                      backgroundColor: 'transparent',
                      color: '#E6F2FF',
                      fontFamily: 'poppins',
                      fontWeight: 300,
                      '&:hover': {
                        bgcolor: 'rgb(33, 132, 253)',
                        color: '#E6F2FF',
                      },
                    }}
                  >
                    Close
                  </Button>

                  <Box display="flex" alignItems="center">
                    <Button
                      onClick={handleOpenFinalContractDialog}
                      startIcon={<SignNowIcon />}
                      sx={{
                        px: 4,
                        height: matchessm ? 35 : 42,
                        borderRadius: '5px',
                        fontSize: matchessm ? '12px' : '14px',
                        textTransform: 'none',
                        border: '1px solid #E6F2FF',
                        backgroundColor: '#FFF',
                        color: '#2184FD',
                        fontWeight: 400,
                        fontFamily: 'poppins',
                        '&:hover': {
                          bgcolor: '#FFFFFF',
                          color: '#2184FD',
                        },
                      }}
                    >
                      Prepare
                    </Button>
                  </Box>
                </Stack>
              </Box>
            </Grid>

            <Grid
              item
              xs={12}
              md={4}
              display={matchesmd ? 'none' : 'block'}
              textAlign="center"
            >
              <img
                src={SigningcontractImage}
                alt="SigningcontractImage"
                style={{ objectFit: 'contain', height: '275px' }}
              />
            </Grid>
          </Grid>
        </Card>
      </Grid>
      {openFinalContractDialog && (
        <FinalContractUploadDialog
          open={openFinalContractDialog}
          onClose={handleCloseFinalContractDialog}
          onSubmit={handleFinalContractSubmit}
          streetName={bannerDetails?.addressFull}
          matchessm={matchessm}
          userType={'Agent'}
          buyerId={buyerId}
          propertyIdbanner={Number(bannerDetails?.propertyId)}
        />
      )}
      {openPrepareDialog && (
        <PrepareContractSignDialog
          open={openPrepareDialog}
          onCancel={handleClosePrepareDialog}
          onSuccess={handleCloseAllContractDialogs}
          pdfFile={uploadedPdf}
          streetName={bannerDetails?.addressFull}
          matchessm={matchessm}
          contractFileUrl={uploadedContractUrl}
          propertyId={Number(bannerDetails?.propertyId)}
          buyerId={buyerId}
          fromDashboard={true}
          userName={bannerDetails?.buyerFullName}
        />
      )}
    </>
  );
};

export default RequestedESignContract;
